var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowsG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 16,
    viewBox: "0 0 101 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0865 1.52381C40.6415 3.96191 39.4651 13.8937 37.0865 13.4762C17.2812 10 6.091 16 4.42459 16C2.75817 16 -4.57393 12.1905 4.31363 6.09524C13.2012 0 32.6427 -1.52381 37.0865 1.52381Z",
    className: "Brows"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2465 1.52381C59.6915 3.96191 60.8679 13.8937 63.2465 13.4762C83.0518 10 94.242 16 95.9084 16C97.5748 16 104.907 12.1905 96.0194 6.09524C87.1318 0 67.6903 -1.52381 63.2465 1.52381Z",
    className: "Brows"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsG);
export default __webpack_public_path__ + "static/media/Brows G.61edce5b59234af8edded86fcb95c048.svg";
export { ForwardRef as ReactComponent };